// extracted by mini-css-extract-plugin
export default {"main":"App_main__UDMbR","content":"App_content__941RR","bar":"App_bar__FSK3r","info":"App_info__Qh9an","toggleLanguage":"App_toggleLanguage__elb6K","logo":"App_logo__5ESCr"};